var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['font-bold w-fit p-[10px] rounded', _vm.badgeColor]},[_vm._v(" "+_vm._s(_vm.statusOrderLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }